import React from "react";
import { Link } from "react-router-dom";
import { Page, Button } from "../../../design-system";
import { colors } from "../../../design-system/theme/colors";
import FilterClients from "./components/Filter";
import NoCertificateWarning from "../_components/NoCertificateWarning";

const Clients = () => {
    const editClient = (client) => {
        window.location.href = `/clients/${client.id}`;
    };

    return (
        <Page 
            title="Clientes" 
            subtitle={<span>Gerencie sua base de clientes. Clique <Link to="/clients/create" style={{ color: colors.brandLightBlue, fontWeight: 600 }}>aqui</Link> para cadastrar um novo.</span>}
        >
            <NoCertificateWarning />
            <div className="row mb-5">
                <div className="col-12" style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
                    <Button onClick={() => window.location.href = '/clients/create'}>
                        + Cadastrar novo cliente
                    </Button>
                    <button 
                        className="btn btn-outline-primary"
                        style={{ background: '#fff', border: '1px solid #1a73e8', color: '#1a73e8', display: 'flex', alignItems: 'center', gap: '5px', padding: '10px 15px', borderRadius: '4px', fontWeight: 600, cursor: 'pointer' }}
                        onClick={() => window.dispatchEvent(new CustomEvent('exportClientCsv'))}
                    >
                        <i className="fas fa-file-excel"></i> Exportar cadastros de clientes para CSV
                    </button>
                </div>
                <div className="col-12">
                    <FilterClients onClick={editClient} />
                </div>
            </div>
        </Page>
    );
};

export default Clients;


// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/index.jsx